<template>
  <q-card class="q-pa-md">
    <div class="row q-col-gutter-lg">
      <div class="col-3">
        <q-img :src="preset.imageUrl" />
      </div>
      <div class="col-6">
        <div class="text-h6">
          {{ preset.label }}
        </div>
        <div class="text-body1">
          {{ preset.description}}
        </div>
      </div>
      <div class="col-3">
        <div class="text-center fit flex items-center justify-center">
          <InstallBtn
            :account-id="accountId"
            :preset="preset"
            color="primary"
            size="lg"
            rounded
            unelevated
            no-caps
            @installed="$emit('installed', $event)"
          />
        </div>
      </div>
    </div>
  </q-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IntegrationPreset } from '@/iam/types';
import InstallBtn from './preset/InstallBtn.vue';

export default defineComponent({
  emits: ['installed'],
  components: { InstallBtn },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    preset: {
      type: Object as () => IntegrationPreset,
      required: true,
    },
  },
});
</script>
